module.exports = __webpack_public_path__ + "static/media/address-icon.3f10b497.svg";